import { faWarning } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled from 'styled-components'

import GuideMeButton from '@/components/GuideMeButton'

const Container = styled.div`
  background-color: #ad6200;
  color: #fff;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 8px;
  padding: 0 12px;
`

const IconWrapper = styled.div`
  margin-right: 8px;
  display: inline-block;
`

export interface Props {
  onClick: () => void
  copy: string
  isDisabled?: boolean
}

export const GuideMeBanner = ({ onClick, copy, isDisabled = false }: Props) => {
  return (
    <Container>
      <div>
        <IconWrapper>
          <FontAwesomeIcon
            color={'#fff'}
            icon={faWarning}
            size="lg"
            data-testid="icon"
            className="warning-icon"
          />
        </IconWrapper>
        {copy}
      </div>
      <GuideMeButton disabled={isDisabled} onClick={onClick} />
    </Container>
  )
}
